"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSessionExpired = exports.onLogout = exports.onEnhanceAuthenticationResult = void 0;
__exportStar(require("./authentication-service"), exports);
__exportStar(require("./injection-symbols"), exports);
var lifecycle_hooks_1 = require("./lifecycle-hooks");
Object.defineProperty(exports, "onEnhanceAuthenticationResult", { enumerable: true, get: function () { return lifecycle_hooks_1.onEnhanceAuthenticationResult; } });
Object.defineProperty(exports, "onLogout", { enumerable: true, get: function () { return lifecycle_hooks_1.onLogout; } });
Object.defineProperty(exports, "onSessionExpired", { enumerable: true, get: function () { return lifecycle_hooks_1.onSessionExpired; } });
__exportStar(require("./use-api"), exports);
//# sourceMappingURL=index.js.map